module.exports = __webpack_public_path__ + "img/indexType_4.3bd4a8ae.png";